import React, { Component } from 'react'
import './topBar.css'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import {
    NavigationContainer,
} from '../Navigation/Navigation.js'
import { MediaTitleContainer } from './MediaTitle'

class TopBar extends Component {

    static propTypes = {
        isResponsiveModeEnabled: PropTypes.bool.isRequired,
        t: PropTypes.func.isRequired,
    }

    render() {
        const { isResponsiveModeEnabled } = this.props

        return (
            <div className="top-bar print-hidden">
                    {
                        ! isResponsiveModeEnabled &&
                        <div className="media-title-wrapper"><MediaTitleContainer /></div>
                    }
                <div className="navigation-wrapper">
                    <NavigationContainer />
                </div>
            </div>
        )
    }
}

export default withTranslation()(TopBar)
